import React, { type FC, type PropsWithChildren, createContext } from 'react';
import { type BiLogger } from './types';

export interface BiLoggerProviderProps {
  biLogger: BiLogger;
}

export const BiLoggerContext = createContext<BiLogger>(null);

export const BiLoggerProvider: FC<PropsWithChildren<BiLoggerProviderProps>> = ({ biLogger, children }) => (
  <BiLoggerContext.Provider value={biLogger}>{children}</BiLoggerContext.Provider>
);
